export default __webpack_public_path__ + "static/Fiber-b077bfbca518a4d90f1fc0a1628c9637.png";